import { showValidationMessage, closePasswordModal, updateAPIActionFeedback } from '.'
import * as ApiBase from '../../APIBase'
import { updateActionMessage } from '../../shared/actionFeedback/actions'

export const resetPassword = (params) => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const { email } = getState().profile.info

  const successMessage = 'Password changed successfully!'

  const URL = `/${subPath}/customer/reset_password`

  const json = await ApiBase.put(URL, {
    ...params,
    email: email.value ? email.value : email,
  }, accessToken)

  dispatch(updateAPIActionFeedback(true))
  dispatch(updateActionMessage({
    message: json.success ? successMessage : json.message,
    success: json.success,
  }))

  setTimeout(() => {
    dispatch(updateAPIActionFeedback(false))
    dispatch(updateActionMessage({
      message: '',
      success: json.success,
    }))
    if (json.success) {
      dispatch(closePasswordModal())
    }
  }, 5000)

  dispatch(showValidationMessage(json.success, json.message))
}
